var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stateOptions)?_c('div',{staticClass:"csfg__slider"},_vm._l((_vm.images),function(image,key){return _c('NewSliderImg',{key:image.id,attrs:{"img":image,"imageIndex":key,"zoom":_vm.stateOptions.zoom,"active":key == _vm.stateOptions.image,"showPins":_vm.stateOptions.pin}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }